<template>
  <div :class="['flex p-1', isVertical ? 'flex-col' : 'flex-row', isVertical ? '' : 'ml-auto']">
    <button v-if="showSettings" class="rounded-md p-2 hover:bg-white/10" @click="onSettingsClick">
      <slot name="settings-icon">
        <SettingsIcon class="h-5 w-5" />
      </slot>
    </button>
    <NavigationPaneItem
      v-if="!isLoggedIn"
      label="Login / Sign Up"
      id="login"
      href="/login2"
      :expanded="expanded"
    />
    <NavigationPaneItem
      v-if="isLoggedIn"
      label="Logout"
      id="logout"
      :expanded="expanded"
      @click="onLogout"
    />
    <NavigationSeparator
      v-if="canExpand && (showSettings || showAuth)"
      :isHorizontal="!isVertical"
    />
    <NavigationPaneToggle
      v-if="canExpand"
      :position="position"
      :expanded="expanded"
      @toggle="onToggle"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { useRouter } from 'vue-router'
import { type Position } from '../types/NavigationPane'
import { SettingsIcon } from '@/components/icons'
import NavigationSeparator from './Separator.vue'
import NavigationPaneToggle from './NavigationPaneToggle.vue'
import NavigationPaneItem from './NavigationPaneItem.vue'
import { removeAuthToken, removePlayerOpenedResults } from '@/helpers/storage'

export default defineComponent({
  name: 'NavigationPaneUtils',
  components: {
    SettingsIcon,
    NavigationSeparator,
    NavigationPaneToggle,
    NavigationPaneItem
  },
  props: {
    canExpand: {
      type: Boolean,
      default: false
    },
    expanded: {
      type: Boolean,
      default: false
    },
    position: {
      type: String as () => Position,
      default: 'left'
    },
    showSettings: {
      type: Boolean,
      default: false
    },
    showAuth: {
      type: Boolean,
      default: true
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle', 'settings', 'exit', 'login'],
  setup(props, { emit }) {
    const isVertical = computed(() => props.position === 'left' || props.position === 'right')
    const onToggle = () => {
      emit('toggle')
    }
    const onSettingsClick = () => {
      emit('settings')
    }
    const onExitClick = () => {
      emit('exit')
    }
    const router = useRouter()
    const onLogout = async () => {
      removeAuthToken()
      removePlayerOpenedResults()
      await router.push('/home')
      window.location.reload()
    }
    return {
      isVertical,
      onToggle,
      onSettingsClick,
      onExitClick,
      onLogout
    }
  }
})
</script>
